module.exports = __webpack_public_path__ + "components/rewards/panda-optics/static/logo-43ae277bdf23ab94a9640959514417cb.webp";